









import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import OfferResourceList from '@superUI/ResourceList/OfferResourceList'
import CsvExportResourceTriggerModal from '@triggers/Utils/CsvExportResourceTriggerModal'
import AcceptPendingOfferTriggerModal from '@triggers/Offer/AcceptPendingOfferTriggerModal'
import BulkEditOffersTriggerModal from '@triggers/Offers/BulkEditOffersTriggerModal'
import ExtendOffersExpirationTriggerModal from '@triggers/Offers/ExtendOffersExpirationTriggerModal'

settings =
  name: 'OfferList'
  components: {
    SuperContainerView,
    OfferResourceList,
    CsvExportResourceTriggerModal,
    AcceptPendingOfferTriggerModal,
    BulkEditOffersTriggerModal,
    ExtendOffersExpirationTriggerModal,
  }

  resources:
    offers:
      resourceName: 'offers'
      slug: 'offers'
      infinityScroll: true

  vue:
    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      csvExportResourceTrigger: (payloadOptions) ->
        @$refs.csvExportResourceTrigger.fire(@exportCsvParams("offers", payloadOptions))

      onOffersCsvExport: ->
        @$refs.csvExportResourceTrigger.close()

      onOffersCsvExportError: -> @showError('Failed to export csv')

      acceptPendingOfferTrigger: (offer) ->
        payloadOptions = { offer_id: offer.id }
        modalOptions = { offer }
        @$refs.acceptPendingOfferTrigger.fire(payloadOptions, modalOptions)
      onOffersAgreeToTermsAndAccept: ->
        @$refs.acceptPendingOfferTrigger.close()

      bulkEditOffersTrigger: (payload, modalConfig) ->
        @$refs.bulkEditOffersTrigger.fire payload, modalConfig
      onOffersBulkEdit: ->
        @$refs.bulkEditOffersTrigger.close()

      promptToExtendOffersExpiration: (offers) ->
        payloadOptions = { offer_ids: offers.map((o) => o.id) }
        modalOptions = {}
        @$refs.extendOffersExpirationTrigger.fire(payloadOptions, modalOptions)
      onOffersExtendOffersExpiration: ->
        @$refs.extendOffersExpirationTrigger.close()
        @$refs.offerResourceList.clearSelection()

export default VueOptions.vue settings
